const animations = {
    init() {
        let self = this;

		const scriptUrls = [
			'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js',
			'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js',
		  ];

		window.initPackages(scriptUrls).then(() => {
			self._fireInTheHole();
		}).catch((error) => {
			console.error(error);
		});
    },

	_fireInTheHole() {
		let self = this;

		if(document.querySelectorAll('.js-move-mockup').length > 0) {
			self._movingImgs();
        }

		if(document.querySelectorAll('.js-move-quotes').length > 0) {
			self._moveQuotes();
		}

		if(document.querySelectorAll('.js-fade-in-bottom').length > 0) {
			self._fadeInBottom();
		}
		
		if(document.querySelector('.js-chat')) {
			self._showChat();
		}
	},

	_fadeInBottom() {
		let items = document.querySelectorAll('.js-fade-in-bottom');

		items.forEach(item => {
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: 'top bottom',
					end: 'bottom bottom',
				},
		
				y: 0,
				autoAlpha: 1,
				duration: 0.5,
				ease: 'power2.easeOut',
			});
		});
    },

	_showChat() {
		let self = this;
		let tl = gsap.timeline({paused: true});

		tl.to('.js-chat', {autoAlpha: 1, x: 0, duration: 0.2, ease: 'power2.easeOut'});
		tl.pause();

		ScrollTrigger.create({
            start: "top top",
            end: 99999,
            onUpdate: (self) => {

                if(self.scroll() > 400) {
					tl.play();
                }

				if(self.scroll() < 400) {
					tl.reverse();
				}
            }
        });
	},

    _movingImgs() {

		ScrollTrigger.matchMedia({
	
			// desktop
			"(min-width: 576px)": function() {
				gsap.to(".js-move-mockup img", {
					yPercent: -5,
					scale: 1,
					ease: "power2.out",
					duration: 2,
					scrollTrigger: {
					  trigger: ".js-header-trigger",
					  start: "top top", // when the center of the trigger hits 40% from the top of the viewport
					  end: "bottom  bottom", // end after scrolling 1000px beyond the start
					  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
					  
					}
				  });
		
				gsap.to(".js-move-foreground img", {
					yPercent: -15,
					scale: 1,
					ease: "power2.out",
					duration: 2,
					scrollTrigger: {
						trigger: ".js-header-trigger",
						start: "top top", // when the center of the trigger hits 40% from the top of the viewport
						end: "bottom  bottom", // end after scrolling 1000px beyond the start
						scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
						
					}
				  });
			},
			"(max-width: 575.9px)": function() {
				gsap.to(".js-move-mockup img", {
					yPercent: -10,
					scale: 1,
					ease: "power2.out",
					duration: 2,
					scrollTrigger: {
					  trigger: document.querySelector('.js-header-trigger').closest('section'),
					  start: "top top", // when the center of the trigger hits 40% from the top of the viewport
					  end: "bottom  bottom", // end after scrolling 1000px beyond the start
					  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
					}
				  });
		
				gsap.to(".js-move-foreground img", {
					yPercent: -30,
					scale: 1,
					ease: "power2.out",
					duration: 2,
					scrollTrigger: {
						trigger: document.querySelector('.js-header-trigger').closest('section'),
						start: "top top", // when the center of the trigger hits 40% from the top of the viewport
						end: "bottom  bottom", // end after scrolling 1000px beyond the start
						scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
					}
				  });
			}
		});

        
    },

    _moveQuotes() {
      gsap.to(".js-move-quotes img", {
        yPercent: '-15',
        ease: "power2.out",
        duration: 2,
        scrollTrigger: {
            trigger: document.querySelector('.js-move-quotes').closest('section'),
            start: "top bottom", // when the center of the trigger hits 40% from the top of the viewport
            end: "bottom bottom", // end after scrolling 1000px beyond the start
            scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
           
        }
      });
    },
};

document.addEventListener('bodyLoadingFinished', function() {
	animations.init();	
});

/*animations.init();

document.addEventListener('LokiRequestEnd', function () {
    animations.init();
});*/
